<div class="d-flex flex-row align-items-center m-2">
  <div class="d-flex flex-grow-1" #content>
    <ng-content></ng-content>
  </div>
  <div class="d-flex" style="gap: 10px">
    @if (showPreviousStep) {
      <button [disabled]="disableButtons" mat-raised-button (click)="previousStep()">
        <mat-icon>navigate_before</mat-icon>
        {{'form.previousStep' | translate}}
      </button>
    }
    @if (showNextStep) {
      <button [disabled]="disableButtons" mat-raised-button (click)="nextStep()">
        <mat-icon>navigate_next</mat-icon>
        {{'form.nextStep' | translate}}
      </button>
    }
  </div>
</div>
